import React from 'react';

// 根据实际 shaixuan.svg 内容填充 path（示例为占位符，需替换为真实 SVG 路径）
const DownloadIcon = ({name, color}) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={name} width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M3 12.0042V21H21V12" stroke={color} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16.5 11.5L12 16L7.5 11.5" stroke={color} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.9961 3V16" stroke={color} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default DownloadIcon;
